import { Heading, Paragraph } from '@audio-network/componentlibrary'
import React, { useRef } from 'react'

import Flyout from '../../../Flyout'
import { ViewNotesProps } from './ViewNotes.types'
import styles from './ViewNotes.module.css'

const ViewNotes: React.FC<ViewNotesProps> = ({
	id,
	isOpen,
	onClose,
	notes,
	...flyoutProps
}) => {
	const viewNotesRef = useRef(null)

	return (
		<>
			<Flyout
				className={styles.viewNotes}
				data-testid="track-notes"
				id={id}
				isOpen={isOpen}
				onClose={onClose}
				{...flyoutProps}
				ref={viewNotesRef}
			>
				<div className={styles.viewNotesScrollable}>
					<Heading className={styles.viewNotesTitle} level={2} size="XS">
						{/* TODO: Translate */}
						Notes
					</Heading>
					<Paragraph css="white-space: pre-line;" size="S">
						{notes}
					</Paragraph>
				</div>
				{/* TODO: Translate */}
				<button className={styles.viewNotesCloseButton} onClick={onClose}>
					Close
				</button>
			</Flyout>
		</>
	)
}

export default ViewNotes
